export default __webpack_public_path__ + "static/media/settings-icon.b7d3a38a.svg";